import React from "react";
import Img from "gatsby-image";

const NavItem = ({ name }) => (
  <li style={{ cursor: "pointer" }}>
    <a data-nav-section={name.replace(/[^a-zA-Z0-9]/, "-")}>{name}</a>
  </li>
);

export default ({
  location,
  job,
  name,
  profileImage,
  sections,
  socialMedia
}) => (
  <aside
    className="border js-fullheight"
    id="colorlib-aside"
    role="complementary"
  >
    <div className="text-center">
      <img className="author-img" alt={name} src={profileImage.file.url} />
      <h1 id="colorlib-logo">
        <a href="/">{name}</a>
      </h1>
      <span className="position">
        <a>{job}</a> in {location}
      </span>
    </div>
    <nav className="navbar" id="colorlib-main-menu" role="navigation">
      <div className="collapse" id="navbar">
        <ul>{sections.map(name => <NavItem name={name} key={name} />)}</ul>
      </div>
    </nav>
    {socialMedia &&
      socialMedia.length && (
        <div className="colorlib-footer" style={{ backgroundColor: "#2c98f0" }}>
          <ul>
            {socialMedia.map(({ type, fullUrl, customHtml }) => (
               customHtml && customHtml.customHtml ? <li dangerouslySetInnerHTML={{ __html: customHtml.customHtml }}/> : 
                <li key={type}>
                <a href={fullUrl}>
                  <i className={`icon-${type}`} />
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
  </aside>
);

//<Img className={styles.heroImage} alt={data.name} sizes={data.heroImage.sizes} />



// WEBPACK FOOTER //
// ./src/components/aside.js